import { AlertService } from '../../shared/services/alert.service';
import { AuthService } from '../../login/services/auth.service';
import { OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Company } from "../../shared/models/company";
import { CompanyService } from "../../shared/services/company.service";
import { DacConfig } from 'app/shared/services/dac-config.service';
import { AmplifyService } from 'aws-amplify-angular';
import { MetricsService } from 'app/shared/services/metrics.service';
var SignupComponent = /** @class */ (function () {
    function SignupComponent(companyService, router, route, authService, amplifyService, alertService, dacConfig, elementRef, metrics) {
        var _this = this;
        this.companyService = companyService;
        this.router = router;
        this.route = route;
        this.authService = authService;
        this.amplifyService = amplifyService;
        this.alertService = alertService;
        this.dacConfig = dacConfig;
        this.elementRef = elementRef;
        this.metrics = metrics;
        this.processingSignup = false;
        this.METRIC_CATEGORY = 'signup';
        this._company = new Company();
        this.isPerformingAction = false;
        this._authState = 'signUp';
        this._authStateSubscription = this.amplifyService.authStateChange$.subscribe(function (authState) {
            _this._authState = authState.state;
        });
        // this.amplifyService.setAuthState({state: 'signUp', user:null});
    }
    SignupComponent.prototype.ngOnDestroy = function () {
        if (this._authStateSubscription) {
            this._authStateSubscription.unsubscribe();
        }
    };
    SignupComponent.prototype.ngOnInit = function () {
        this.signupLogo = this.dacConfig.applicationLogoUrl;
        this.amplifyService.setAuthState({ state: 'signUp', user: null });
    };
    SignupComponent.prototype.trackSignup = function (action, name) {
        this.metrics.trackEvent(this.METRIC_CATEGORY, action, name);
    };
    Object.defineProperty(SignupComponent.prototype, "authState", {
        get: function () {
            return this._authState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignupComponent.prototype, "Company", {
        get: function () {
            return this._company;
        },
        enumerable: true,
        configurable: true
    });
    SignupComponent.prototype.handlePlan = function (plan) {
        // custom will go to the contact page.
        if (plan == "Therapist") {
            this.handleCTA();
        }
        return;
    };
    SignupComponent.prototype.handleCTA = function () {
        var el = this.elementRef.nativeElement;
        var home = el.querySelector("#home");
        home.scrollIntoView(true);
    };
    SignupComponent.prototype.showPartner = function (partner) {
        if (this.dacConfig.hasPartner(partner)) {
            return true;
        }
        return false;
    };
    SignupComponent.prototype.confirmSignup = function () {
        var _this = this;
        this.trackSignup('confirmSignup');
        var code = this.confirmationCode.trim();
        this.processingSignup = true;
        this.amplifyService
            .auth()
            .confirmSignUp(this.Company.email, code)
            .then(function () {
            _this.trackSignup('confirmSignup', 'cognito confirmed');
            _this.registerNewCompany();
        })
            .catch(function (error) {
            _this.trackSignup('confirmSignup', 'code invalid or error');
            _this.processingSignup = false;
            console.error(error);
            var msg = error.message || error || "There was an error in confirming your code.  Please try again or contact support";
            _this.alertService.error(msg);
        });
    };
    SignupComponent.prototype.resendConfirmationCode = function (evt) {
        var _this = this;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.trackSignup('resentConfirmationCode');
        this.amplifyService
            .auth()
            .resendSignUp(this.Company.email)
            .then(function () {
            _this.trackSignup('resentConfirmationCode', 'code resent');
            _this.alertService.info("Confirmation code resent. Check your email for confirmation");
        })
            .catch(function (error) {
            _this.trackSignup('resentConfirmationCode', 'code failed to resend');
            console.error(error);
            _this.alertService.error("There was an error resending the confirmation code.  Please try again");
        });
        return false;
    };
    SignupComponent.prototype.signup = function () {
        var _this = this;
        this.trackSignup('signupClicked');
        // we are going to clear our local storage to make sure everything is reset
        try {
            sessionStorage.clear();
            localStorage.clear();
        }
        catch (error) {
            this.trackSignup('signupClicked', 'clear storage failed');
            console.error("Failed to clear local and session storage", error);
        }
        if (!this.Company.name || this.Company.name.trim() == "") {
            this.alertService.error("Please provide a name for your company");
            this.trackSignup('signupClicked', 'invalid company name');
            return;
        }
        if (!this.Company.email || this.Company.email.trim() == "" || this.Company.email.indexOf("@") < 0) {
            this.trackSignup('signupClicked', 'invalid email');
            this.alertService.error("Please provide a valid email for your company");
            return;
        }
        var passwordPolicyMsg = "Password must be 8 characters or more, contain at least one number(0-9), one uppercase letter(a-z), and one lowercase letter(A-Z)";
        if (!this.password || this.password.length < 8) {
            this.trackSignup('signupClicked', 'invalid password length');
            this.alertService.error(passwordPolicyMsg);
            return;
        }
        if (!this.password.match(/[0-9]+/)) {
            this.trackSignup('signupClicked', 'invalid password number');
            this.alertService.error(passwordPolicyMsg);
            return;
        }
        if (!this.password.match(/[A-Z]+/)) {
            this.trackSignup('signupClicked', 'invalid password uppercase');
            this.alertService.error(passwordPolicyMsg);
            return;
        }
        if (!this.password.match(/[a-z]+/)) {
            this.trackSignup('signupClicked', 'invalid password lowercase');
            this.alertService.error(passwordPolicyMsg);
            return;
        }
        // if (this.password != this.confirmPassword) {
        //   this.alertService.error("Passwords do not match");
        //   return;
        // }
        this.processingSignup = true;
        this._company.user.username = this.Company.email;
        this.amplifyService.auth().signUp({
            // email: this.Company.email,
            username: this.Company.email,
            password: this.password,
            attributes: {
                //   email: this.Company.email,          // optional
                'custom:companyName': this.Company.name
            },
            validationData: [] //optional
        })
            .then(function (data) {
            _this.trackSignup('signupClicked', 'cognito signup');
            // TODO: stephen do we save off the lead here...
            _this.processingSignup = false;
            _this.amplifyService.setAuthState({ state: 'confirmSignUp', user: data.user });
        })
            .catch(function (err) {
            if (err.code === "UsernameExistsException") {
                _this.trackSignup('signupClicked', 'duplicate email');
                _this.alertService.error("That email address already exists.  Please choose a different one or login");
            }
            else if (err.code == 'InvalidParameterException') {
                _this.trackSignup('signupClicked', 'invalid cognito parameter');
                _this.alertService.error(err.message);
            }
            else {
                _this.trackSignup('signupClicked', 'system error occurred');
                _this.alertService.error("There was an error creating your account.  Check your information and try again or contact our support");
            }
            _this.processingSignup = false;
            console.log(err);
        });
    };
    SignupComponent.prototype.registerNewCompany = function () {
        var _this = this;
        this.trackSignup('registerNewCompany');
        // this._company.user.password = this.password;
        // TODO: need to handle any referral and other pieces of information as part of this registration
        var user = this.amplifyService.auth().signIn(this._company.email, this.password)
            .then(function (user) {
            _this.trackSignup('registerNewCompany', 'cognito signIn success');
            var authToken = user.signInUserSession.accessToken.jwtToken;
            // registration will only work if there is a valid auth token here...
            _this.companyService.registerNewCompany(_this._company, authToken)
                .then(function (company) {
                _this.trackSignup('registerNewCompany', 'company registered');
                // now let's login in and authenticate here...              
                _this.authService.authenticateCognito(user).then(function () {
                    _this.trackSignup('registerNewCompany', 'authentication complete');
                    _this.password = "";
                    _this.alertService.success("Registration complete. Sending you on to your dashboard.");
                    setTimeout(function () {
                        _this.router.navigate(["/admin/"]);
                        _this.processingSignup = false;
                    }, 3000);
                })
                    .catch(function (error) {
                    _this.trackSignup('registerNewCompany', 'authentication failed');
                    _this.processingSignup = false;
                    console.error(error);
                    _this.alertService.error("Failed to log you in.  Redirecting to login page");
                    _this.router.navigate(["/loginAdmin"]);
                });
            })
                .catch(function (error) {
                _this.trackSignup('registerNewCompany', 'company registration failed');
                _this.processingSignup = false;
                console.error(error); // TODO: stephen this error needs to be transmitted to the server.
                _this.alertService.error("Failed to sign you in and complete creation of your account.  Please contact customer support for assistance.");
                _this.amplifyService.auth().signOut({ global: true }); // sign out if we failed to login.
                _this.amplifyService.setAuthState({ state: 'signUp', user: null });
            });
        })
            .catch(function (error) {
            _this.trackSignup('registerNewCompany', 'cognito signIn failed');
            console.error(error); // TODO: stephen this error needs to be transmitted to the server.
            _this.alertService.error("Failed to sign you in and complete creation of your account.  Please contact customer support for assistance.");
        });
    };
    SignupComponent.prototype.getFreeTrialPeriod = function () {
        return 14;
    };
    return SignupComponent;
}());
export { SignupComponent };



// WEBPACK FOOTER //
// ./src/app/companies/signup/signup.component.ts.pre-build-optimizer.js